import React, { ComponentProps, ReactNode } from 'react';
import { environment } from '~/config/public';

export interface ShareFacebookProps extends ComponentProps<'a'> {
  url: string;
  children: ReactNode;
}
const ShareFacebook = ({
  url = '',
  children,
  ...props
}: ShareFacebookProps) => {
  const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${environment.baseUrl}${url}`;

  return (
    <a {...props} href={fbUrl} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

export default ShareFacebook;
